import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformEnvironmentAPIErrorErrorCode {
  ProxyEnvironmentConnectTimeout = 'ProxyEnvironmentConnectTimeout',
  ProxyWaitAPITimeout = 'ProxyWaitAPITimeout',
  ProxyContextsError = 'ProxyContextsError',
  IncorrectExpose = 'IncorrectExpose',
}

class EditorPlatformEnvironmentAPIError extends BaseError<EditorPlatformEnvironmentAPIErrorErrorCode> {
  state: Partial<{
    url: string;
    appDefinitionId: string;
  }> = {};

  constructor(
    message: string,
    code: EditorPlatformEnvironmentAPIErrorErrorCode,
  ) {
    super(message, code, 'EP EnvironmentAPI Error');
  }

  withUrl(url: string) {
    this.state = { ...this.state, url };
    return this;
  }

  withAppDefinitionId(appDefinitionId: string) {
    this.state = { ...this.state, appDefinitionId };
    return this;
  }
}

export const createEditorPlatformEnvironmentAPIError = createErrorBuilder<
  EditorPlatformEnvironmentAPIErrorErrorCode,
  EditorPlatformEnvironmentAPIError
>(EditorPlatformEnvironmentAPIError);
